<template>
  <div class="page-container">
    <div class="content content-wrapper">
      <!-- 成功提示 -->
      <div class="success-message">
        <div class="icon-wrapper">
          <img src="@/assets/order_img.png" />
        </div>
        <div class="text">提交成功</div>
      </div>

      <!-- 信息卡片 -->
      <div class="info-card">
        <p>1、平台1~3个工作日内受理，请耐心等待！</p>
        <p>2、如未退回设备请联系平台客服获取收货地址退回设备！</p>
        <div class="divider"></div>
        <button class="contact-btn" @click="contactCustomerService">
          联系客服
        </button>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-button">
      <button @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 可以在这里添加需要动态显示的数据
    };
  },
  mounted() {
    // 页面加载完成后的操作
  },
  computed: {
    // 计算属性
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 联系客服
    contactCustomerService() {
      window.location.href = "tel:" + this.appData.customerPhone;
    },
  },
};
</script>

<style lang="less" scoped>
/* 全局容器 */
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f7f8fa;
  color: #333;
}

.content {
  flex: 1;
  padding: 0 32px;
}

/* 为导航栏留出位置 */
.content-wrapper {
  padding-top: 40px;
  padding-bottom: 120px;
}

/* 成功提示 */
.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  margin-bottom: 60px;
  .icon-wrapper {
    margin-bottom: 20px;
    img {
      width: 98px;
      height: 98px;
    }
  }
  .text {
    font-size: 30px;
    color: #333;
  }
}

/* 信息卡片 */
.info-card {
  background-color: #fff;
  border-radius: 20px;
  padding: 32px;
  p {
    font-size: 30px;
    line-height: 1.6;
    color: #4e5969;
  }
  .divider {
    height: 1px;
    background-color: #eee;
    margin: 20px 0;
  }
  .contact-btn {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 32px;
    color: var(--primary-color);
    border: none;
    background: none;
    padding: 20px 0;
  }
}

/* 底部按钮 */
.bottom-button {
  position: fixed;
  bottom: 60px; // 增加底部间距，适配安全区域
  left: 32px;
  right: 32px;

  button {
    width: 100%;
    height: 96px;
    background: var(--primary-color);
    border: none;
    border-radius: 16px;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
